import React from "react";
import { IoCloseSharp } from "react-icons/io5";

import { useStateContext } from "../contexts/ContextProvider";

const Iframe = () => {
  const { activeIframe, setActiveIframe } = useStateContext();

  const handlePopup = () => {
    setActiveIframe(!activeIframe);
  };

  const iframe =
    '<iframe style="height: 100vh; width:100%;" scrolling="no" src="https://calendly.com/levelup-academe/2-hours" frameborder="no" allowtransparency="true" allowfullscreen="true"></iframe>';

  return (
    <>
      {activeIframe && (
        <div className="w-screen fixed top-0 bg-white z-10">
          <div className="flex justify-end m-4 text-3xl">
            <IoCloseSharp
              className="rounded-2xl bg-blue-100 hover:bg-gray-200 z-30"
              onClick={handlePopup}
            />
          </div>
          <div className="flex fixed top-0 right-0 left-0 justify-between p-3 bg-blue-100  border-gray-300 border-b-1 z-20">
            <div id="logo" className="text-blue-600 text-center text-4xl">
              Level<span className="text-pink-500">Up</span>&nbsp; Acade
              <span className="text-pink-500">Me</span>
            </div>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: iframe ? iframe : "",
            }}
          />
        </div>
      )}
    </>
  );
};

export default Iframe;
